var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:var(--text-light);stroke-linecap:round;stroke-linejoin:round;stroke-width:2;}")), /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 30",
    id: "Layer_30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.52,13.59,63,13.39l-7.1,28H20.23l-8.86-32H1.25"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 23.83,
    cy: 52.17,
    r: 3.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 53.1,
    cy: 52.17,
    r: 3.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.65,
    x2: 58.29,
    y1: 32.1,
    y2: 32.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15,
    x2: 60.7,
    y1: 22.56,
    y2: 22.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.15,
    x2: 24.15,
    y1: 13.54,
    y2: 41.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.83,
    x2: 15.83,
    y1: 13.54,
    y2: 25.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.41,
    x2: 32.41,
    y1: 13.54,
    y2: 41.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 40.66,
    x2: 40.66,
    y1: 13.54,
    y2: 41.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 48.92,
    x2: 48.92,
    y1: 13.54,
    y2: 41.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 57.18,
    x2: 57.18,
    y1: 13.54,
    y2: 36.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.23,41.41V45.7a2.55,2.55,0,0,0,2.55,2.55H53.24"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.61eaca9912f81bf471df1954815edb7d.svg";
export { ForwardRef as ReactComponent };